a<template>
  <Dialog :visible="visible" @hide="cerrarDialog">
    <template #header>
      <h3>{{ localPregunta.id ? 'Editar Pregunta' : 'Nueva Pregunta' }}</h3>
    </template>
    <template #content>
      <div>
        <InputText v-model="localPregunta.texto" placeholder="Texto de la Pregunta" />
      </div>
    </template>
    <template #footer>
      <ButtonPrime label="Cancelar" @click="cerrarDialog" />
      <ButtonPrime label="Guardar" @click="guardarPregunta" />
    </template>
  </Dialog>
</template>

<script>
import { ref, watch } from 'vue';
import { Dialog } from 'primevue/dialog';
import { ButtonPrime } from 'primevue/button';
import { InputText } from 'primevue/inputtext';

export default {
  components: {
    Dialog,
    ButtonPrime,
    InputText,
  },
  props: {
    visible: Boolean,
    pregunta: Object,
    cerrarDialog: Function,
    guardarPregunta: Function,
  },
  setup(props) {
    const localPregunta = ref({ ...props.pregunta }); // Crea una copia local de la prop

    watch(() => props.pregunta, (newPregunta) => {
      localPregunta.value = { ...newPregunta }; // Actualiza la copia local si la prop cambia
    });

    return {
      localPregunta,
    };
  },
};
</script>

<style scoped>
.pregunta-dialog {
  width: 500px;
}
</style>